export class CancelSale
{
  motivo: string;
  descricao: string;
  observacoes: string;
  novoDocumento: boolean;
  movimentaStock: boolean;
}
